import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import "./styles.css";
export default function StyledInput(props) {

 const onChange = (event) => {
    props.onChange(event.target.value, event.target.name);
  }

 const clearInput = () => {
    props.onChange('');
  }

  const onKeyDown = (event) => {
    // Prevent the default behavior if the '.' key is pressed
    if (event.key === '.') {
      event.preventDefault();
    }
  }

  const {
    value,
    type,
    name,
    placeholder,
    customClass = '',
    onFocus,
    disabled,
    errorMsg,
    withClear,
    startAdornment='',
    endAdornment='', 
    discountType,
    flag=false,
    isFromAddStops=false,
    // onChange,
  } = props;
  const errMsgClasses = classNames({ 'fl-error-msg': errorMsg }, { 'fl-error-show': errorMsg });
  return (
    <div >
    {
      withClear && value && !disabled &&
        <div className="fl-input-clear" onClick={clearInput} />
    }
   {flag ? <div className={isFromAddStops ? 'rest-input-container' : "custom-input-container"}>
      {discountType === 'FLAT' && (
        <label className="adornment start-adornment" htmlFor='input-box'>
          {startAdornment}
        </label>
      )}
      <input
        id='input-box'
        type={type}
        name={name}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onFocus={onFocus || null}
        placeholder={placeholder}
        className='input-field'
        onKeyDown={onKeyDown}
      />
      {discountType !== 'FLAT' && (
        <label className="adornment end-adornment" htmlFor='input-box'>
          {endAdornment}
        </label>
      )}
    </div> : <input
      type={type}
      name={name}
      value={value}
      disabled={disabled}
      className={value ? 'inputBoxValue' : 'inputBox'}
      onChange={onChange}
      onFocus={onFocus || null}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
    />}
    <span className="fl-input-bar" />
    { errorMsg && <span className={errMsgClasses}>{errorMsg}</span> }
  </div>
  );
}
StyledInput.propTypes = {
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  placeholder: PropTypes.string,
  customClass: PropTypes.string,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};